import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconPlay from 'components/icons/iconPlay2';
import IconPause from 'components/icons/iconPause';
const VideoPlayButton = t0 => {
  const $ = _c(24);
  const {
    color: t1,
    styling: t2,
    isPlaying: t3,
    onClick,
    disabled: t4,
    size: t5,
    children
  } = t0;
  const color = t1 === undefined ? "transparent" : t1;
  const styling = t2 === undefined ? "outline-button" : t2;
  const isPlaying = t3 === undefined ? true : t3;
  const disabled = t4 === undefined ? false : t4;
  const size = t5 === undefined ? "base" : t5;
  const t6 = styling === "solid-button";
  const t7 = styling === "outline-button";
  const t8 = styling === "outline-button" && color === "transparent";
  const t9 = styling === "outline-button" && color === "black";
  const t10 = styling === "outline-button" && color === "brand";
  const t11 = size === "xs";
  const t12 = size === "sm";
  const t13 = size === "base";
  const t14 = size === "lg";
  const t15 = size === "xl";
  const t16 = size === "2xl";
  const t17 = size === "3xl";
  const t18 = size === "4xl";
  let t19;
  if ($[0] !== t10 || $[1] !== t11 || $[2] !== t12 || $[3] !== t13 || $[4] !== t14 || $[5] !== t15 || $[6] !== t16 || $[7] !== t17 || $[8] !== t18 || $[9] !== t6 || $[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t19 = classNames("font-sans flex flex-row no-underline justify-evenly font-bold", {
      "VideoPlayButton--styling-solid-button": t6,
      "min-w-[140px] px-[0.8rem] py-8 inline-flex h-[50px] flex-row items-center justify-between border-2 bg-transparent": t7,
      "border-transparent": t8,
      "border-gray text-gray hover:border-brand hover:text-brand": t9,
      "border-brand text-brand hover:border-brand hover:text-brand": t10,
      "text-xs": t11,
      "text-sm": t12,
      "text-base": t13,
      "text-lg": t14,
      "text-xl": t15,
      "text-2xl": t16,
      "text-3xl": t17,
      "text-4xl": t18
    });
    $[0] = t10;
    $[1] = t11;
    $[2] = t12;
    $[3] = t13;
    $[4] = t14;
    $[5] = t15;
    $[6] = t16;
    $[7] = t17;
    $[8] = t18;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t19;
  } else {
    t19 = $[13];
  }
  let t20;
  if ($[14] !== children) {
    t20 = <span className="text-lg">{children}</span>;
    $[14] = children;
    $[15] = t20;
  } else {
    t20 = $[15];
  }
  let t21;
  if ($[16] !== isPlaying) {
    t21 = <span className="VideoPlayButton__icon">{!isPlaying ? <IconPlay width="15px" height="15px" /> : <IconPause width="15px" height="15px" />}</span>;
    $[16] = isPlaying;
    $[17] = t21;
  } else {
    t21 = $[17];
  }
  let t22;
  if ($[18] !== disabled || $[19] !== onClick || $[20] !== t19 || $[21] !== t20 || $[22] !== t21) {
    t22 = <button onClick={onClick} disabled={disabled} className={t19} type="button">{t20}{t21}</button>;
    $[18] = disabled;
    $[19] = onClick;
    $[20] = t19;
    $[21] = t20;
    $[22] = t21;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  return t22;
};
VideoPlayButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  styling: PropTypes.oneOf(['solid-button', 'outline-button']),
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl']),
  color: PropTypes.oneOf(['brand', 'black', 'white', 'transparent']),
  disabled: PropTypes.bool,
  isPlaying: PropTypes.bool
};
export default VideoPlayButton;